import { Playground } from 'docz';
import { useTimeInterval, useToggle } from "../../../../../src/index";
import * as React from 'react';
export default {
  Playground,
  useTimeInterval,
  useToggle,
  React
};